import moment from "moment";
import React, { Fragment, useEffect, useReducer, useState } from "react";
import { addTestResult } from "../../api/addTestResult";
import TestQues from "../../components/testQues/testQues";
import { getStudentData } from "../../helper/localStorage";
import { totalTimeOrScore } from "../../helper/scoreCounter";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import TestFooter from "../testFooter/testFooter";
import "./tTextMatch.scss";

const initialVal = (allQue) => {
  allQue = allQue.map((que) => {
    return { ...que, userAns: "", correct: false };
  });
  return {
    allQue,
    selectedAns: [],
    totalQue: allQue.length,
    attempted: [],
    unattempted: [],
    correct: [],
    incorrect: [],
  };
};
const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "SELECTED_ANS": {
      // ans, index, ques_____payload
      const userAllQue = [...state.allQue];
      let unattempted = [];
      let attempted = [];
      let correct = [];
      let incorrect = [];

      const sortAns = (value) => {
        return value
          .sort(function (a, b) {
            return a - b;
          })
          .join();
      };

      let length = 0;
      let count = 0;
      let newSelectedAns = [...payload.ans];

      newSelectedAns.forEach((answer) => {
        const regex = new RegExp(payload.index + "_[1-9]");
        if (regex.test(answer)) {
          length++;
        }
      });

      //test for only 2 touch

      if (length > 2) {
        newSelectedAns = payload.ans.filter((answer) => {
          const regex = new RegExp(payload.index + "_[1-9]");
          if (regex.test(answer)) {
            count++;
            return count !== 3;
          }
          return true;
        });
      }

      const getUserAns = (index) => {
        let filAns = [];
        // sort and join tapped answer
        console.log("payload.ans", payload.ans);
        console.log("newSelectedAns", newSelectedAns);
        // let count = 0;
        // payload.ans.forEach((myAns) => {
        //   let arrAns = myAns.split("_");
        //   if (arrAns[0] === index.toString()) {
        //     filAns = [...filAns, arrAns[1]];
        //   }
        // });
        newSelectedAns.forEach((myAns) => {
          let arrAns = myAns.split("_");
          if (arrAns[0] === index.toString()) {
            filAns = [...filAns, arrAns[1]];
          }
        });
        return sortAns(filAns);
      };

      const userSelectedArr = userAllQue.map((uAllQue, index) => {
        const getUserAttempts = (theQue) => {
          if (theQue.userAns === "") {
            unattempted = [...unattempted, theQue];
          } else {
            attempted = [...attempted, theQue];
            //correct incorrect logic
            if (theQue.correct_choice === theQue.userAns) {
              correct = [...correct, theQue];
            } else {
              incorrect = [...incorrect, theQue];
            }
          }
        };
        if (payload.index === index) {
          let userAns = getUserAns(index);
          const useAllQueR = {
            ...uAllQue,
            userAns,
            correct: userAns === uAllQue.correct_choice,
          };
          getUserAttempts(useAllQueR);
          return useAllQueR;
        } else {
          getUserAttempts(uAllQue);
          return uAllQue;
        }
      });

      // const newSelectedAns = payload.ans.filter((answer) => {
      //   const arr = answer.split("_");
      //   if (arr[0] === payload.index.toString()) {
      //     count++;
      //     console.log("count", count);
      //     return count <= 2;
      //   }
      //   return true;
      // });
      console.log("newSelectedAns", newSelectedAns);
      return {
        ...state,
        // selectedAns: payload.ans,
        selectedAns: newSelectedAns,
        allQue: userSelectedArr,
        unattempted,
        attempted,
        correct,
      };
    }
    default:
      return state;
  }
};
export default function TextMatch({ question, questions, index }) {
  const { login_id } = getStudentData();
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();
  const [startTime, setStartTime] = useState();
  const [userRec, dispatchUserRec] = useReducer(
    reducer,
    initialVal(question.que)
  );

  const { selectedAns } = userRec;

  console.log("question", question);

  const grade_id =
    helperC.testType === "CALIBRATION"
      ? "5"
      : JSON.parse(localStorage.getItem("gradeId"));

  useEffect(() => {
    setStartTime(moment());
  }, []);

  useEffect(() => {
    dispatchAnswer({
      type: "TEXT_MATCHING_ATTEMPT",
      payload: userRec.attempted.length,
    });
  }, [userRec.allQue]);

  const getTimeSpend = () => {
    return Math.ceil(moment().diff(startTime) / 1000);
  };

  // creating array of tapped answer
  const handleMultiChoice = (answer, index, ques) => {
    let ans = [...selectedAns];
    if (ans.includes(answer)) {
      ans = ans.filter((ans) => ans !== answer);
      dispatchUserRec({ type: "SELECTED_ANS", payload: { ans, index, ques } });
    } else {
      ans = [...ans, answer];
      dispatchUserRec({
        type: "SELECTED_ANS",
        payload: { ans, index, ques },
      });
    }
    // if (ans.includes(answer)) {
    //   ans = ans.filter((ans) => ans !== answer);
    //   dispatchUserRec({
    //     type: "SELECTED_ANS",
    //     payload: { ans, index, ques, testId: question.test_id },
    //   });
    // } else {
    //   ans = [...ans, answer];
    //   dispatchUserRec({
    //     type: "SELECTED_ANS",
    //     payload: { ans, index, ques, testId: question.test_id },
    //   });
    // }
  };

  const isActive = (choice) => {
    if (selectedAns.includes(choice)) {
      return "active";
    } else {
      return "";
    }
  };

  const userChoice = (number, choice, index, ques) => {
    return (
      <>
        {choice && (
          <div className="text-match-choice-wrap">
            <div
              className={`text-match-choice ${isActive(number)}`}
              onClick={() => handleMultiChoice(number, index, ques)}
            >
              <h1>{choice}</h1>
            </div>
          </div>
        )}
      </>
    );
  };

  const handleSubmit = () => {
    console.log("handle Submit run");
    const ansForApi = userRec.allQue.map((que) => {
      return {
        answer: que.userAns,
        que_id: que.id,
        file_encoded: "",
        file_path: "",
        file_type: "",
        json_res: "",
        que_score: que.correct ? 1 : 0,
        que_time: getTimeSpend(),
      };
    });

    dispatchAnswer({
      type: "ADD_ANSWER",
      payload: userRec.allQue,
    });

    const { player_score, player_time } = totalTimeOrScore(
      ansForApi,
      questions
    );
    const formatValue = {
      grade_id,
      player_id: login_id,
      res: ansForApi,
      player_image: "",
      player_time: Math.ceil(getTimeSpend()),
      player_score,
      test_id: question.test_id,
    };
    addTestResult(formatValue, dispatchHelper, dispatchAnswer);
  };

  useEffect(() => {
    dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
    if (helperC.isNextQues) {
      handleSubmit();
    }
  }, [helperC.isNextQues]);

  return (
    <div
      className="test-body-content"
      style={{ justifyContent: "flex-start", overflow: "auto", height: "75%" }}
    >
      <TestQues question={question.que[0]} />
      {userRec.allQue.map((ques, index) => {
        const myIndex = index.toString();
        return (
          <Fragment key={index}>
            <div key={index} className={`text-match-choices`}>
              <div className="">
                <h1 className="text-match-number">{index + 1}</h1>
              </div>
              {userChoice(`${myIndex}_1`, ques.choice_1, index, ques)}
              {userChoice(`${myIndex}_2`, ques.choice_2, index, ques)}
              {userChoice(`${myIndex}_3`, ques.choice_3, index, ques)}
              {userChoice(`${myIndex}_4`, ques.choice_4, index, ques)}
              {userChoice(`${myIndex}_5`, ques.choice_5, index, ques)}
              {userChoice(`${myIndex}_6`, ques.choice_6, index, ques)}
            </div>
          </Fragment>
        );
      })}
      <TestFooter
        isUserInput={userRec.attempted.length === 50}
        //FIXME comment below before push
        // isUserInput={userRec.attempted.length !== 50}
        question={question}
        questions={questions}
        index={index}
      />
    </div>
  );
}
